/**
 * navigation.js — header dính, mega menu, menu quốc gia, drawer mobile và tab bar.
 *
 * Markup đầu vào chỉ cần output của wp_nav_menu() (ul.menu > li.menu-item-has-children
 * > a + ul.sub-menu) cộng khung mega của walker; script này tự chèn:
 *   · button.submenu-toggle sau tiêu đề mỗi mục có con (caret / dấu +)
 *   · button.submenu-back ở đầu mỗi "màn hình" cấp 2 trong drawer
 * nên PHP không phải sinh phần điều khiển.
 *
 * Desktop (>= 1024): mega menu và menu quốc gia mở bằng CSS hover/focus-within (trễ
 * 150ms, đóng sau 300ms) — JS thêm bấm để mở, rê chuột đổi danh mục / quốc gia đang
 * chọn, Esc và bấm ra ngoài để đóng.
 * Mobile: drawer trượt từ trái; danh mục và "Quốc gia" mở thành màn hình mới trượt từ
 * phải, nhóm lọc và vùng chạy accordion.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var DESKTOP_QUERY = '(min-width: 1024px)';

    var header = document.querySelector('[data-site-header]');
    var nav = document.getElementById('site-navigation');
    var toggles = [].slice.call(document.querySelectorAll('[data-nav-toggle]'));

    function isDesktop() {
        return window.matchMedia(DESKTOP_QUERY).matches;
    }

    function each(selector, scope, fn) {
        [].slice.call((scope || document).querySelectorAll(selector)).forEach(fn);
    }

    // ----- Header dính: đo chiều cao phần còn hiện + thu gọn khi cuộn -----
    if (header) {
        var utility = header.querySelector('.site-header__utility');

        // Header dính với top âm bằng thanh tiện ích, nên phần thật sự che nội dung
        // khi cuộn = cả header trừ thanh tiện ích. Biến này dùng cho scroll-padding
        // và cột dính (sidebar bộ lọc, mục lục).
        var measure = function () {
            var height = header.offsetHeight - (utility ? utility.offsetHeight : 0);
            document.documentElement.style.setProperty('--header-height', height + 'px');
        };

        // Bật ở 120px, tắt dưới 60px: thanh chính co 80 → 64px làm trang dịch lên,
        // một ngưỡng duy nhất sẽ làm header bật tắt liên tục quanh mép ngưỡng.
        var stuck = false;
        var onScroll = function () {
            var y = window.pageYOffset;
            var next = stuck ? y > 60 : y > 120;
            if (next === stuck) return;
            stuck = next;
            header.classList.toggle('is-stuck', next);
            window.setTimeout(measure, 220);
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', measure);
        window.addEventListener('load', measure);
        onScroll();
        measure();
    }

    if (!nav) return;

    // ----- Chèn nút mở cấp con -----
    function labelOf(item) {
        var label = item.querySelector(':scope > a, :scope > .mega-menu__group-title');
        return label ? label.textContent.trim() : '';
    }

    function setOpen(item, open) {
        item.classList.toggle('is-open', open);
        var button = item.querySelector(':scope > .submenu-toggle');
        if (button) button.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function setActive(item) {
        each(':scope > .menu-item', item.parentNode, function (sibling) {
            sibling.classList.toggle('is-active', sibling === item);
        });
    }

    each('.menu-item-has-children', nav, function (item) {
        var label = item.querySelector(':scope > a, :scope > .mega-menu__group-title');
        if (!label) return;

        var isTop = item.parentNode.id === 'primary-menu';
        var isGroup = !!item.closest('.mega-menu__groups');
        var isRow = !!item.parentNode.closest('.mega-menu__cats, .countries-menu') && !isGroup;

        var icon = isTop ? 'ph-caret-down' : isGroup ? 'ph-plus' : 'ph-caret-right';
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'submenu-toggle';
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-label', 'Mở ' + labelOf(item));
        button.innerHTML = '<i class="ph-bold ' + icon + '" aria-hidden="true"></i>';
        label.insertAdjacentElement('afterend', button);

        button.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();

            if (isDesktop()) {
                if (isTop) {
                    var willOpen = !item.classList.contains('is-open');
                    closeTop(item);
                    item.classList.remove('is-closed');
                    setOpen(item, willOpen);
                } else if (isRow) {
                    setActive(item);
                }
                return;
            }

            // Mobile: accordion cho nhóm lọc và vùng, màn hình mới cho phần còn lại
            if (isGroup) {
                var icn = button.querySelector('i');
                var open = !item.classList.contains('is-open');
                setOpen(item, open);
                if (icn) icn.className = 'ph-bold ' + (open ? 'ph-minus' : 'ph-plus');
            } else if (item.parentNode.classList.contains('countries-menu')) {
                setOpen(item, !item.classList.contains('is-open'));
            } else {
                setOpen(item, true);
                var back = item.querySelector('.submenu-back');
                if (back) back.focus();
            }
        });

        // Desktop: rê chuột đổi danh mục / quốc gia đang chọn ngay, không cần bấm
        if (isRow) {
            item.addEventListener('mouseenter', function () {
                if (isDesktop()) setActive(item);
            });
            label.addEventListener('focus', function () {
                if (isDesktop()) setActive(item);
            });
        }

        if (isTop) {
            item.addEventListener('mouseleave', function () {
                item.classList.remove('is-closed');
            });
        }
    });

    // ----- Nút quay lại cho màn hình cấp 2 trong drawer -----
    function addBack(screen, item) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'submenu-back';
        button.innerHTML = '<i class="ph-bold ph-caret-left" aria-hidden="true"></i>';
        button.appendChild(document.createTextNode(labelOf(item)));
        button.addEventListener('click', function () {
            setOpen(item, false);
            var toggle = item.querySelector(':scope > .submenu-toggle');
            if (toggle) toggle.focus();
        });

        // ul chỉ được chứa li — bọc nút trong một li riêng
        if (screen.tagName === 'UL') {
            var li = document.createElement('li');
            li.className = 'submenu-back-item';
            li.appendChild(button);
            screen.insertBefore(li, screen.firstChild);
        } else {
            screen.insertBefore(button, screen.firstChild);
        }
    }

    each('.mega-menu__cats > .menu-item-has-children', nav, function (item) {
        var panel = item.querySelector(':scope > .mega-menu__panel');
        if (panel) addBack(panel, item);
    });

    each('.menu-item--countries', nav, function (item) {
        var list = item.querySelector(':scope > .countries-menu');
        if (list) addBack(list, item);
    });

    // ----- Đóng menu cấp 1 trên desktop -----
    function closeTop(except) {
        each('#primary-menu > .menu-item-has-children', nav, function (item) {
            if (item !== except) setOpen(item, false);
        });
    }

    // Đóng mọi thứ đang mở trong drawer (màn hình cấp 2, accordion)
    function resetDrawer() {
        each('.is-open', nav, function (item) {
            if (item === nav) return;
            setOpen(item, false);
        });
        each('.mega-menu__groups .submenu-toggle i', nav, function (icon) {
            icon.className = 'ph-bold ph-plus';
        });
    }

    // ----- Drawer -----
    var lastFocused = null;

    function openNav() {
        lastFocused = document.activeElement;
        nav.classList.add('is-open');
        document.body.classList.add('u-no-scroll');
        toggles.forEach(function (toggle) {
            toggle.setAttribute('aria-expanded', 'true');
        });
        var close = nav.querySelector('.main-navigation__close');
        if (close) close.focus();
    }

    function closeNav() {
        if (!nav.classList.contains('is-open')) return;
        nav.classList.remove('is-open');
        document.body.classList.remove('u-no-scroll');
        toggles.forEach(function (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
        });
        // Đợi drawer trượt ra hết rồi mới dọn, tránh thấy màn hình cấp 2 giật về
        window.setTimeout(resetDrawer, 320);
        if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    toggles.forEach(function (toggle) {
        toggle.addEventListener('click', function () {
            if (nav.classList.contains('is-open')) closeNav();
            else openNav();
        });
    });

    each('[data-nav-close]', nav, function (el) {
        el.addEventListener('click', closeNav);
    });

    // Bấm link sang trang khác thì đóng drawer
    nav.addEventListener('click', function (event) {
        var link = event.target.closest ? event.target.closest('a[href]') : null;
        if (link && link.getAttribute('href').charAt(0) !== '#') closeNav();
    });

    // ----- Bấm ra ngoài / Esc -----
    document.addEventListener('click', function (event) {
        if (isDesktop() && !nav.contains(event.target)) closeTop();
    });

    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' && event.key !== 'Esc') return;
        if (isDesktop()) {
            // Chuột còn nằm trên menu thì :hover vẫn giữ menu mở — .is-closed ép đóng
            each('#primary-menu > .menu-item-has-children', nav, function (item) {
                if (item.matches(':hover, :focus-within') || item.classList.contains('is-open')) {
                    item.classList.add('is-closed');
                }
                setOpen(item, false);
            });
            if (document.activeElement && nav.contains(document.activeElement)) document.activeElement.blur();
        } else {
            closeNav();
        }
    });

    // ----- Đổi breakpoint: dọn trạng thái -----
    var resizeTimer;
    window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
            if (isDesktop()) {
                closeNav();
                resetDrawer();
            } else {
                closeTop();
            }
        }, 150);
    });

    // ----- Thanh hành động đáy (trang sản phẩm, giỏ hàng) -----
    // Chiều cao đổi theo nội dung (tên sản phẩm dài, dòng "Tiết kiệm…") nên đo thật rồi
    // đẩy vào --action-bar-height để body chừa đúng khoảng trống, không đoán số cố định.
    // ResizeObserver bắt cả khi chính thanh đổi cao (dòng "Tiết kiệm" ẩn/hiện, giỏ trống
    // thì ẩn thanh) chứ không chỉ lúc đổi cỡ cửa sổ.
    var actionBar = document.querySelector('.action-bar');
    if (actionBar) {
        var measureBar = function () {
            document.documentElement.style.setProperty('--action-bar-height', actionBar.offsetHeight + 'px');
        };
        if (window.ResizeObserver) {
            new ResizeObserver(measureBar).observe(actionBar);
        } else {
            window.addEventListener('resize', measureBar);
            window.addEventListener('load', measureBar);
        }
        measureBar();
    }

    // ----- Tab bar mobile: đánh dấu tab của trang đang xem -----
    // WP: PHP gắn aria-current theo is_front_page() / is_page(); bản tĩnh so tên file.
    var current = window.location.pathname.split('/').pop() || 'index.html';
    each('.bottom-bar__tab[href]', document, function (tab) {
        if (tab.getAttribute('href') !== current) return;
        tab.setAttribute('aria-current', 'page');
        var icon = tab.querySelector('.bottom-bar__icon i');
        if (icon) icon.className = icon.className.replace('ph-bold', 'ph-fill');
    });
})();
